import { render, staticRenderFns } from "./BotaoProtecaoDados.vue?vue&type=template&id=5dd4345a&scoped=true&"
import script from "./BotaoProtecaoDados.vue?vue&type=script&lang=js&"
export * from "./BotaoProtecaoDados.vue?vue&type=script&lang=js&"
import style0 from "./BotaoProtecaoDados.vue?vue&type=style&index=0&id=5dd4345a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd4345a",
  null
  
)

export default component.exports